import React, { useState, useRef, useEffect } from 'react';
import styles from './FeatureGridSection.module.css'; // CSS Modules
import { Helmet } from 'react-helmet';
const faqs = [
  {
    question: "How experienced is Dr. Shruti Sagar in advanced gastroenterology procedures?",
    answer:
      "Dr. Shruti Sagar has 8 years expertise with 500+ ERCP and 300+ EUS procedures, making him one of Hyderabad's most experienced gastroenterologists.",
  },
  {
    question: "What makes Dr. Shruti Sagar different from other gastroenterologists in Hyderabad?",
    answer:
      "Dr. Sagar combines advanced procedural skills, research excellence (published author), international training, and patient-focused care approach.",
  },
  {
    question: "Can Dr. Shruti Sagar handle complex gastro cases?",
    answer:
      "Absolutely. Dr. Sagar specializes in complex ERCP, therapeutic EUS, emergency procedures, and difficult-to-diagnose conditions.",
  },
  {
    question: "What hospitals is Dr. Shruti Sagar affiliated with?",
    answer:
      "Dr. Sagar is Associate Consultant at Yashoda Hospitals, Secunderabad, and practices at Krisara Gastro Clinic, Kompally.",
  },
  {
    question: "Does Dr. Shruti Sagar provide consultations in Telugu?",
    answer:
      "Yes, Dr. Sagar is fluent in Telugu, Hindi, and English, ensuring comfortable communication for all patients.",
  },
  {
    question:"What are Dr. Shruti Sagar's areas of special interest?",
    answer:"Dr. Sagar specializes in advanced endoscopy, therapeutic interventions, hepato-pancreaticobiliary diseases, and liver disorders."
  },
  {
    question:"Has Dr. Shruti Sagar presented at international conferences?",
    answer:"Yes, Dr. Sagar presented at EUS Summit 2024 in Seoul, ESGE Days 2024 in Berlin, and multiple national conferences."
  },
    {
    question:"Can I get a second opinion from Dr. Shruti Sagar?",
    answer:"Yes, Dr. Sagar provides expert second opinions via telemedicine or in-person consultations for complex GI conditions."
  },
    {
    question:"What is Dr. Shruti Sagar's success rate with ERCP procedures?",
    answer:": Dr. Sagar maintains >95% technical success rate with ERCP procedures, with minimal complications due to his expertise."
  },
    {
    question:"How can I contact Dr. Shruti Sagar directly?",
    answer:"You can reach Dr. Sagar at +91-9959981290 or sagar1292@gmail.com for appointments and consultations."
  },
    {
    question:"What training does Dr. Shruti Sagar have in liver diseases?",
    answer:"Dr. Sagar has extensive training in hepatology during his DM program and continues advanced liver disease management."
  },
    
    {
    question:"What patients say about Dr. Shruti Sagar's care?",
    answer:"Patients consistently praise Dr. Sagar's expertise, gentle approach, clear explanations, and successful treatment outcomes"
  },
  {
    question:"Does Dr. Shruti Sagar provide dietary counseling?",
    answer:"Yes, Dr. Sagar provides comprehensive dietary guidance for all digestive and liver conditions as part of holistic care."
  }
];
const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": faqs.map(faq => ({
    "@type": "Question",
    "name": faq.question,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": faq.answer
    }
  }))
};

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "MedicalOrganization",
    name: "Krisara Gastro and Liver Clinic",
    url: "https://krisaragastro.com/",
    logo: "https://i.ibb.co/HDcnBZt3/Rectangle-76.png",
    image: "https://i.ibb.co/HDcnBZt3/Rectangle-76.png",
    telephone: "+91 7569541532",
    email: "gastro@krisara.com",
    address: {
      "@type": "PostalAddress",
      streetAddress:
        "3rd Floor, Fairmount Square, Pet Basheerabad, Quthbullapur, Kompally",
      addressLocality: "Hyderabad",
      addressRegion: "Telangana",
      postalCode: "500014",
      addressCountry: "IN",
    },
    sameAs: [
      "https://www.facebook.com/krisaragastro",
      "https://www.instagram.com/krisaragastro",
    ],
  };

function FeatureGridSection() {
  const [openIndex, setOpenIndex] = useState(-1);
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => {
      if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
  }, []);
  return (
    <>
      <section className={styles.section}>
        <h2 className={styles.heading}>
          Why Patients Choose Dr. Shruti Sagar
        </h2>
        <div className={styles.subtitle}>
          Every aspect of care designed around your comfort and recovery
        </div>
        <div className={styles.grid}>
          {/* Card 1 */}
          <div className={styles.card}>
            <span className={styles.icon}>
              <img src="https://i.ibb.co/1fJxS1js/Group.png" alt="Expert Care Icon- Best Gastroenterologist in Kompally Hyderabad - Krisara Gastro Clinic" />
            </span>
            <div className={styles.cardTitle}>Expert Care</div>
            <div className={styles.cardDesc}>
              500+ Advanced Procedures Completed. Dr. Shruti Sagar brings 8 years of specialized expertise with proven success in complex ERCP, EUS, and therapeutic endoscopy procedures, ensuring you receive world-class treatment.
            </div>
          </div>
          {/* Card 2 */}
          <div className={styles.card}>
            <span className={styles.icon}>
              <img src="https://i.ibb.co/0jWPh7BF/Group-1.png" alt="Patient Satisfaction Icon - Best Gastroenterologist in Kompally Hyderabad - Krisara Gastro Clinic" />
            </span>
            <div className={styles.cardTitle}>95%+ Patient Satisfaction Rate</div>
            <div className={styles.cardDesc}>
              Our track record speaks for itself – consistently successful outcomes, minimal complications, and thousands of patients restored to optimal digestive health across Hyderabad.
            </div>
          </div>
          {/* Card 3 */}
          <div className={styles.card}>
            <span className={styles.icon}>
              <img src="https://i.ibb.co/cKDYbSXT/Group-2.png" alt="Personalised Treatment Icon- Best Gastroenterologist in Kompally Hyderabad - Krisara Gastro Clinic" />
            </span>
            <div className={styles.cardTitle}>Personalised Treatment</div>
            <div className={styles.cardDesc}>
              Tailored Care Plans For Every Patient. No two patients are alike. Dr. Sagar creates individualized treatment strategies based on your specific condition, lifestyle, and health goals for optimal recovery.
            </div>
          </div>
          {/* Card 4 */}
          <div className={styles.card}>
            <span className={styles.icon}>
              <img src="https://i.ibb.co/yn6pKZLW/archive-content-1.png" alt="Advanced Technology Icon- Best Gastroenterologist in Kompally Hyderabad - Krisara Gastro Clinic" />
            </span>
            <div className={styles.cardTitle}>Advanced Technology</div>
            <div className={styles.cardDesc}>
              Latest Medical Equipment & Techniques. From High-Definition endoscopy to precision EUS procedures, we utilize cutting-edge technology to ensure accurate diagnosis and minimally invasive treatments.
            </div>
          </div>
          {/* Card 5 */}
          <div className={styles.card}>
            <span className={styles.icon}>
              <img src="https://i.ibb.co/4RxtC0CB/folder-favorite-1.png" alt="Quality Assurance Icon - Best Gastroenterologist in Kompally Hyderabad - Krisara Gastro Clinic" />
            </span>
            <div className={styles.cardTitle}>Quality Assurance</div>
            <div className={styles.cardDesc}>
              WEO-WISE Accredited Excellence. Dr. Sagar’s international accreditation and continuous medical education ensure you receive care that meets the highest global standards in gastroenterology.
            </div>
          </div>
          {/* Card 6 */}
          <div className={styles.card}>
            <span className={styles.icon}>
              <img src="https://i.ibb.co/tPzNvyHp/Group-3.png" alt="Comprehensive Support Icon - Best Gastroenterologist in Kompally Hyderabad - Krisara Gastro Clinic" />
            </span>
            <div className={styles.cardTitle}>Comprehensive Support</div>
            <div className={styles.cardDesc}>
              Complete Care from Diagnosis to Recovery. Beyond procedures, we provide ongoing support, dietary guidance, follow-up care, and patient education to ensure your long-term digestive wellness and peace of mind.
            </div>
          </div>
        </div>
      </section>
      {/* FAQ Section */}
      <section
        ref={sectionRef}
        className={`faq-container ${isVisible ? "animate" : ""}`}
      >
        {/* SEO Schema */}
        <Helmet>
          <script type="application/ld+json">
            {JSON.stringify(faqSchema)}
          </script>
        </Helmet>
        <h2 className="faq-title fade-up" style={{ transitionDelay: "0.2s" }}>
          Frequently Asked Questions
        </h2>
        <p className="faq-subtitle fade-up" style={{ transitionDelay: "0.4s" }}>
          Clear answers to the most common queries about our gastro care in
          Kompally, Hyderabad—appointments, procedures, preparation, insurance,
          and recovery. Explore quick guidance below or contact the clinic for
          personalized support.
        </p>
        <a href="tel:+911234567890">
  <button
    className="faq-button fade-up"
    style={{ transitionDelay: "0.6s" }}>
    Reach Out to Us
  </button>
</a>
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="faq-item fade-up"
              style={{ transitionDelay: `${0.8 + index * 0.1}s` }}>
              <div className="faq-question" onClick={() => toggleFAQ(index)}>
                <span>{faq.question}</span>
                <span className="faq-icon">
                  {openIndex === index ? "−" : "+"}
                </span>
              </div>
              {openIndex === index && (
                <div className="faq-answer fade-in">
                  <p>{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
export default FeatureGridSection;